module.exports = __webpack_public_path__ + "static/media/LI16.f36afb82.jpg";